import { createBlock } from '@/lib/parse/blocks';
import { Entry } from '@/lib/parse/entries';

/** Hook to apply card "overrides" and extra features */
export const useLeadershipTeamBlock = createBlock<
  'blocks_leadershipTeam_BlockType',
  NoProps,
  Entry<'profile'>[] | null
>((props) => {
  const { profileMultiple: items } = props;

  // Bail early
  if (!items?.length) return null;

  return items as Entry<'profile'>[];
});
